<template>
  <b-container fluid>
    <admin-preloader :show="loading" />
    <admin-breadcrumb :items="[{text: 'Reports', path: {name: 'admin-reports'}}]" name="New & Repeat Orders" />
    <admin-panel with-header>
      <template #header>
        <b-row>
          <b-col md="3"><b-form-group label="Start date"><b-form-datepicker v-model="filters.start_date" /></b-form-group></b-col>
          <b-col md="3"><b-form-group label="End date"><b-form-datepicker v-model="filters.end_date" :min="filters.start_date" /></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Group by"><b-form-select v-model="filters.group_by" :options="[{value:'vendor',text:'Vendor'}, {value:'product',text:'Product'}]" /></b-form-group></b-col>
          <b-col md="3"><b-form-group label="Repeat definition"><b-form-select v-model="filters.repeat_basis" :options="[{value:'group',text:'Same vendor / product'}, {value:'platform',text:'Any prior platform order'}]" /></b-form-group></b-col>
        </b-row>
        <b-button variant="primary" :disabled="loading" @click="loadReportData">Apply filters</b-button>
        <b-button class="ml-2" :disabled="loading || !rows.length" @click="downloadCsv">Download CSV</b-button>
      </template>
      <p>New means the buyer has no earlier qualifying order under the selected repeat definition. History before the selected date range is included. Buyers are matched by company, then internal license, then registry license. Unidentified buyers or groups appear as unknown.</p>
      <p>Draft, review, cancelled, declined, rejected, deleted and combined-away orders are excluded. Each order counts once per group; product counts across groups may exceed the number of distinct orders. Repeat percentage excludes unknown orders.</p>
      <b-alert :show="!!error" variant="danger">{{ error }}</b-alert>
      <b-table :items="rows" :fields="columns" responsive show-empty striped />
    </admin-panel>
  </b-container>
</template>
<script>
import moment from 'moment';
import AdminPreloader from '../components/AdminPreloader';
import AdminBreadcrumb from '../components/AdminBreadcrumb';
import AdminPanel from '../components/AdminPanel';
import {API_ROUTES} from '../api';
export default {
  name: 'AdminReportNewRepeatOrders',
  components: {AdminPreloader, AdminBreadcrumb, AdminPanel},
  data() {
    return {
      loading: false, error: '', rows: [],
      filters: {
        start_date: this.$route.query.start_date || moment().startOf('month').format('YYYY-MM-DD'),
        end_date: this.$route.query.end_date || moment().format('YYYY-MM-DD'),
        group_by: this.$route.query.group_by || 'vendor',
        repeat_basis: this.$route.query.repeat_basis || 'group'
      },
      columns: [
        {key:'name',label:'Vendor / Product',sortable:true},
        {key:'total_orders',label:'Total Orders',sortable:true},
        {key:'new_orders',label:'New Orders',sortable:true},
        {key:'repeat_orders',label:'Repeat Orders',sortable:true},
        {key:'unknown_orders',label:'Unknown',sortable:true},
        {key:'repeat_percentage',label:'Repeat %',sortable:true,formatter: value => value === null ? '—' : `${value}%`}
      ]
    };
  },
  methods: {
    async loadReportData() {
      this.loading = true;
      this.error = '';
      this.rows = [];
      const params = {...this.filters};
      try {
        const {data} = await this.$api.get(API_ROUTES.ADMIN_REPORT_NEW_REPEAT_ORDERS, {params});
        this.rows = data.report_data.rows;
        await this.$router.replace({query: params}).catch(() => {});
      } catch (error) {
        this.error = error.response && error.response.status === 422 ? 'Check your dates and report options. End date must be on or after start date.' : 'Failed to load report. Please try again.';
      } finally { this.loading = false; }
    },
    downloadCsv() {
      const quote = value => `"${String(value == null ? '' : value).replace(/^[=+@-]/, "'$&").replace(/"/g, '""')}"`;
      const csv = [this.columns.map(column => quote(column.label)).join(','), ...this.rows.map(row => this.columns.map(column => quote(row[column.key])).join(','))].join('\r\n');
      const url = URL.createObjectURL(new Blob(['\uFEFF', csv], {type:'text/csv;charset=utf-8;'}));
      const link = document.createElement('a');
      link.href = url;
      link.download = 'gl_new_repeat_orders.csv';
      link.click();
      URL.revokeObjectURL(url);
    }
  },
  created() { this.loadReportData(); }
};
</script>
